import React from 'react'
import PaymentMethodComp from '../../components/CheckOut/PaymentMethodComp'
import NavBar from '../../components/Layout/NavBar.js'
import Footer from '../../components/Layout/Footer.js'
import { Container, Row } from 'react-bootstrap'
import UseViewSearchProducts from '../../CustomHooks/Products/UseViewSearchProducts.js'

const PaymentMethod = () => {
  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()
  return (
    <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <Container>
        <div className='py-5 mh-100-exact'>
          <PaymentMethodComp />
        </div>
      </Container>
      <Footer />
    </>
  )
}

export default PaymentMethod
